<div
  class="flex flex-col gap-3 rounded-md border border-[#ece8e4] bg-white p-4">
  <div class="text-xs font-semibold tracking-[0.08em] text-gray-500 uppercase">
    Komponenty przesyłki
  </div>

  <div class="flex flex-col gap-3">
    @for (group of groups(); track 'shipment-component-group' + group.name) {
      <section
        class="flex flex-col gap-3 rounded-md border border-gray-200 bg-gray-50 p-4">
        <div
          class="text-xs font-semibold tracking-[0.08em] text-gray-500 uppercase">
          {{ group.name }}
        </div>

        <app-admin-order-components-list [components]="group.components" />
      </section>
    }
  </div>
</div>
